module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--terms"
  }, [_c(_vm.statementContent, {
    tag: "component",
    staticClass: "group group--first-last group--indent typeset typeset--terms links"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d7ee3cc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/Statement.vue
// module id = 450
// module chunks = 0